import React, { useState, useEffect } from 'react';
import AlertMessage from 'components/AlertMessage';
import { bannerDashboardGet } from '../../api';

const DashboardBanner = () => {
    const [message, setMessage] = useState('');

    const writeStorage = (message) => {
        localStorage.setItem('dashboardAlertMessage', JSON.stringify({message: message}))
    }

    const isClosed = () => {
        writeStorage(message)
    }

    const wasClosed = (message) => {
        const localMessage = JSON.parse(localStorage.getItem('dashboardAlertMessage'));
        return message==localMessage?.message
    }

    useEffect(() => {
        bannerDashboardGet({})
        .then(response => {
            setMessage(response.data.body) // response data type
        }).catch(error => {
            console.log(error)
        })
    }, [message]);

    return (
        <>
            { !wasClosed(message) && <AlertMessage alertMessage={message} spaces="" isClosed={isClosed} /> }
        </>
    );
}

export default DashboardBanner;